module.exports = __webpack_public_path__ + "assets/img/img273.fea3fd61.png";